import React, { useEffect, useState } from 'react';
import { SalesPage } from './components/SalesPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
type Page = 'home' | 'terms' | 'privacy';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const navigate = (page: Page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <>
      {currentPage === 'home' && <SalesPage onNavigate={page => navigate(page)} data-id="element-0" />}
      {currentPage === 'terms' && <TermsPage onBack={() => navigate('home')} data-id="element-1" />}
      {currentPage === 'privacy' && <PrivacyPage onBack={() => navigate('home')} data-id="element-2" />}
    </>;
}